export default __webpack_public_path__ + "static/media/shop-n-save-chicken.11b39049.jpg";